import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-query-request',
  templateUrl: './query-request.component.html',
  styleUrls: ['./query-request.component.scss']
})
export class QueryRequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
